const $ = require("jquery");

$(document).ready(() => {
  $(".route-guide__item").on({
    mouseenter: function() {
      $(".route-guide__link").removeClass("route-guide__link--is-active");
      $(this)
        .find(".route-guide__link")
        .addClass("route-guide__link--is-active");
      var className = $(this)
          .attr("class")
          .split("--")
          .pop(),
        image = $(this).data("image");

      $(this)
        .parents(".route-guide")
        .removeClass()
        .addClass("route-guide")
        .addClass("route-guide--" + className);

      $(".route-guide__image__source").attr("src", image);
    }
  });
});
